import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, FieldArray, formValueSelector, Field } from 'redux-form';
import _ from 'lodash';
import { connect } from 'react-redux';

// Components
import { FixedTable } from 'components/content-containers/tables';
import { DateRow, ShippingTaxRow, TotalRow, SubmitRow } from './components/shared-form-components';
import LineItemRows from './components/expense-bill-line-item-rows';
import { RadioInput } from 'components/forms/form-elements';


class ReturnForm extends React.Component {
  static propTypes = {
    cancel: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    header: PropTypes.string,
    form: PropTypes.string.isRequired,
    change: PropTypes.func.isRequired,
    formValues: PropTypes.object.isRequired
  };

  componentWillReceiveProps(nextProps) {
    // If a line item changes, delete the tax so the user has to input it specifically
    if (!_.isEqual(this.props.formValues.lineItems, nextProps.formValues.lineItems)) {
      this.props.change('tax', '');
    }
  }

  render() {
    const { cancel, handleSubmit, header, formValues, ...props } = this.props;
    const { lineItems, tax, shipping, shippingType } = formValues;
    const lineItemTotals = _.map(lineItems, (lineItem) => (lineItem.quantity * lineItem.unitCost) || 0);
    // Shipping can add to or subtract from total based on whether the user has selected that it is a shipping
    // fee or refund, so we take this into account when calculating total
    const shippingWithSign = Number(shippingType === 'fee' ? shipping * -1 : shipping || 0);
    const total = _.sum(lineItemTotals) + shippingWithSign + Number(tax || 0);

    return (
      <form onSubmit={handleSubmit}>
        <FixedTable
          className="form-table"
          invisibleHeaders={[
            'col-enter-receipt-spacing',
            'col-quantity-input',
            'col-money-input',
            'col-money-input',
            ''
          ]}
          headerRow={
            <tr className="form-header-row">
              <th colSpan="5">{header}</th>
            </tr>
          }
        >
          <tbody>
            <DateRow />
          </tbody>
          <FieldArray name="lineItems" component={LineItemRows} lineItems={lineItems} lineItemNote="(Item refund)" />
          <tbody>
            <ShippingTaxRow name="shipping" moneyInputAddonLeft={shippingType === 'fee' ? '-$' : '$'}>
              <Field
                component={RadioInput}
                name="shippingType"
                display="buttons"
                options={[{ text: 'Return shipping fee', value: 'fee' }, { text: 'Shipping refund', value: 'refund' }]}
                tabIndex="-1"
              />
            </ShippingTaxRow>
            <ShippingTaxRow name="tax">
              Tax Refund
            </ShippingTaxRow>
            <TotalRow total={total}>
              Total Refund
            </TotalRow>
            <SubmitRow cancel={cancel} {...props} />
          </tbody>
        </FixedTable>
      </form>
    );
  }
}

const ConnectedForm = connect((state, ownProps) => ({
  formValues: formValueSelector(ownProps.form)(state, 'lineItems', 'shipping', 'tax', 'shippingType')
}))(ReturnForm);

export default reduxForm({ validate: returnValidation })(ConnectedForm);


// Return validation
function returnValidation(values) {
  const errors = {};

  const lineItemsWithQuantity = _.filter(values.lineItems, (lineItem) => Number(lineItem.quantity) > 0);
  if (!lineItemsWithQuantity.length) {
    errors.lineItems = _.map(values.lineItems, () => ({ quantity: ' ' }));
    errors._error = 'You must have at least one line item with a quantity';
  } else {
    errors.lineItems = _.compact(_.map(values.lineItems, (lineItem) => {
      const lineItemErrors = {};
      if (Number(lineItem.quantity) > 0 && !lineItem.unitCost) lineItemErrors.unitCost = 'Required';
      if (Number(lineItem.quantity) > Number(lineItem.billableQuantity)) lineItemErrors.quantity = 'Too many';
      return _.isEmpty(lineItemErrors) ? false : lineItemErrors;
    }));
  }
  
  if (!values.receipt || !values.receipt.length) errors.receipt = 'Required';
  if (values.tax === undefined || values.tax.length === 0) errors.tax = 'Required';

  // If there is an amount in the shipping field, require the user to enter whether it's a shipping fee or refund
  if ((!values.shippingType || !values.shippingType.length) && values.shipping > 0) {
    errors.shippingType = 'Required';
  }

  return errors;
}
